import { render, staticRenderFns } from "./goods-tag.vue?vue&type=template&id=d5e706a4&scoped=true&"
import script from "./goods-tag.vue?vue&type=script&lang=js&"
export * from "./goods-tag.vue?vue&type=script&lang=js&"
import style0 from "./goods-tag.vue?vue&type=style&index=0&id=d5e706a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e706a4",
  null
  
)

export default component.exports